import { UriUtils } from '@ad-lucy/utils';
import { useMemo } from 'react';

export function useSearchParams() {
  return useMemo(() => {
    const searchParams = UriUtils.getQueryParams(window.location.href);
    return {
      previewMode: searchParams['previewMode'] as 'liveRendering' | undefined,
      previewConfig: searchParams['previewConfig'],
    };
  }, []);
}
